import React from 'react';

interface FermentationTankIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

export const FermentationTankIcon: React.FC<FermentationTankIconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 72 80"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Top vent cap */}
    <path d="M34 4h4" />
    <path d="M36 4v4" />

    {/* Top pipe detail - vertical pipe going up then curving right */}
    <path d="M54 8v-6" />
    <path d="M54 2h10" />
    <path d="M64 2v12" />

    {/* Flat top */}
    <path d="M4 8h64" />

    {/* Tank body - left side */}
    <path d="M4 8v42" />

    {/* Tank body - right side */}
    <path d="M68 8v42" />

    {/* Conical bottom - ends at valve width */}
    <path d="M4 50l29 14" />
    <path d="M68 50l-29 14" />

    {/* Bottom outlet valve */}
    <rect x="33" y="64" width="6" height="4" rx="1" />

    {/* Left leg - attached to tank, goes down with foot */}
    <path d="M12 50v18" />
    <path d="M8 68h8" />

    {/* Right leg - attached to tank, goes down with foot */}
    <path d="M60 50v18" />
    <path d="M56 68h8" />

  </svg>
);

export default FermentationTankIcon;
